module.exports = __webpack_public_path__ + "static/media/german_flag.aab1cf99.svg";